import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import {
    ALIGNER_TREATMENT,
    ALIGNER_TREATMENT_EXPECTATION,
    ALIGNER_TREATMENT_MEDICAL_INFORMATION,
    ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT,
    IMPLANT_TREATMENT,
} from '../../../../anamnesis/state/anamnesis/const'

export default {
    taskName: taskName.REDUCER_ENAMEL,
    taskOverviewProps: {},
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.IPR_INSTRUCTIONS_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.PATIENT_IPR_WISHES_WIDGET,
            widgetProps: {
                readOnly: true,
            },
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
            widgetProps: {
                excludeTemplateKeyList: [
                    ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT,
                    ALIGNER_TREATMENT_MEDICAL_INFORMATION,
                    ALIGNER_TREATMENT_EXPECTATION,
                    IMPLANT_TREATMENT,
                ],
            },
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_VISUALIZATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
            widgetProps: {
                excludeTemplateKeyList: [
                    ALIGNER_TREATMENT,
                    ALIGNER_TREATMENT_MEDICAL_INFORMATION,
                    ALIGNER_TREATMENT_EXPECTATION,
                    IMPLANT_TREATMENT,
                ],
            },
        },
        {
            component: processUI.TREATMENT_PLAN_WIDGET,
            readOnly: true,
        },
    ],
    actionList: [
        {
            action: processAction.PROCESS_INSTANCE,
            taskPath: ['processInstance'],
        },
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
        {
            action: processAction.SALES_ORDER,
            taskPath: ['objectDetail'],
        },
        {
            action: processAction.CUSTOMER,
            taskPath: ['objectDetail', 'customer'],
        },
        {
            action: processAction.QUOTATION_CUSTOMER_LOADED,
            taskPath: ['objectDetail', 'customer'],
        },
        {
            action: processAction.TREATMENT_QUOTATION,
            taskPath: ['objectDetail'],
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator: (task, processInstance, taskName, eventName, context) => {
        const messageList = []
        const gotoAlignerNumberUpper = context.gotoAlignerNumberUpper
        const gotoAlignerNumberLower = context.gotoAlignerNumberLower

        if (eventName === 'goto_aligner_step' && (!gotoAlignerNumberUpper || !gotoAlignerNumberLower)) {
            messageList.push(createValidationMessage('Please enter to which aligner the customer should change.', 'checkPhotoCheckin.goto_aligner_step'))
        }

        return messageList
    },
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/treatment/reduce-enamel.js